export const PremiumServicedSites = () => {
    return (
        <div>
            Premium serviced sites
        </div>
    )
}